import { UserEntity } from '../apis/user/user-entity';

export class UserContext {
    private _entity: UserEntity = new UserEntity();

    public get userName(): string { return this._entity.email; }
    public get userEntity(): UserEntity { return this._entity; }
    public get nameIdentifier(): string { return this._entity.nameIdentifier; }
    public get userId(): string { return this._entity.id; }
    public get isLoggedIn(): boolean { return !!this._entity.id; }

    public setUserInfo(userInfo: UserEntity): void {
        this._entity = userInfo;
    }
}
